export default __webpack_public_path__ + "files/1131f0b97b9a32bb3ecabc7a3dadcb49.svg";